import React, { PureComponent } from 'react';
import { BASE_URL } from '../../config';

export default class DependenciesRow extends PureComponent {
  static propTypes = {
    // TODO
  }

  render() {
    const { component, interestingDeps, firstColWidth } = this.props;
    const { name } = component;

    return (
      <div className="row table-row">
        <div className={`col-${firstColWidth}`}>
          <a href={`${BASE_URL}/${name}/latest/index.html`}>{name}</a><br />
        </div>
        {
          interestingDeps.map(dep => (
            <div className="col-1" key={dep.package}>
              {component[dep.source][dep.package] || '-'}
              &nbsp;
            </div>
          ))
        }
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/DependenciesPage/DependenciesRow.jsx